export const environment = {
  logStackTrace: true,
  production: true, 
  driveAppID: 1,
  apiVersion: 'v2',
  apiEndpoint: 'https://api.literax.origon.app/api',
  apiVersionMigr: 'v3',
  apiEndpointMigr: 'https://api.literax.origon.app/migr/api',
  guestApiEndpoint: 'https://api.literax.origon.app',
  sentryDsn: 'https://8f6aef1c590c47e7a56ccaa34e6cd011@sentry.io/1528375',
  domain: 'https://literax.origon.cloud',
  servicesDomain: 'https://services.literax.origon.app',
  paymentWidgetSource:
    'https://mediosdepago.interfactura.com/script/paymentmanager-wd.js',
  paymentClientId: 'B25B0A2F-7FE6-4860-88E1-BE6D15BF399E',
  paymentCustomerId: 'INT020124V62',
  urlAnalytics: 'https://www.googletagmanager.com/gtag/js?id=',
  analyticsId: 'UA-174567452-1',
  widgetUrl:
    'https://gendocs.interfactura.com/DynamicForms.Web/scripts/w3/gdd-widget.js',
  recordUrl: 'https://services.literax.origon.app/fb/v1',
  driveUrl: 'https://front.literax.origon.app/widget/lit-drive.min.js',
  onlyOfficeUrl:
    'https://texteditor.literax.origon.app/web/js/webcomponent.onlyoffice.min.js',
  sendToMailSuggestions: 'buzon@literax.com',
  chatUrl: 'https://front.literax.origon.app/chat_element/lit-chat.min.js',
  literax: 'https://www.literax.com/',
  privacy: 'https://www.literax.com/aviso-de-privacidad/',
  terms: 'https://www.literax.com/terminos-y-condiciones/',
  b2cConfig: {
    clientId: '21ad910a-e7b1-43ca-841f-b79312853155',
    authority:
      'https://login.origon.cloud/idp.origon.cloud/B2C_1A_SIGNUP_SIGNIN',
    knownAuthorities: ['https://login.origon.cloud'],
    scopes: [
      'https://idp.origon.cloud/21ad910a-e7b1-43ca-841f-b79312853155/basic',
      'openid',
      'offline_access',
    ],
  },
  literaxUrl: 'https://www.literax.com',
  onboarding365JoinQueryKey: 'azb2Data',
  captchaKey: '6LesXnksAAAAAFaPImVQAqMOfBzNydmrofXQFnS3',
  enableHotjarTracking: true,
  hotjarVersion: 6,
  hotjarSiteId: 3534844,
  paymentWidgetGetnetConfig:{
    url: "https://www.junomx.com/Banks.Widget",
    b2cCredentials:{
      url: "https://origon2021.b2clogin.com/idp.origon.cloud/b2c_1a_ROPC_Auth/oauth2/v2.0/token",
      user: "literax.integration@origon.io",
      pwd: "cJsBeO6rU9CzzGD",
      grant_type: "password",
      scope: "openid https://idp.origon.cloud/93266ec2-5a04-4ef7-9b2b-e578391f649a/basic offline_access",
      client_id: "93266ec2-5a04-4ef7-9b2b-e578391f649a",
      response_type: "token id_token"
    }
  },
  validatorHeaderLookAndFeel: {
    default: {
      backgroundColor: '#434343',
      actionsBackgroundColor: '#00000073',
      logoUrl: 'https://gdx-cdn.azurewebsites.net/ecosystem/platforms/Literax/images/logo_white.svg',
    },
    Aserta:{
      domains: ['https://asertavn151.literax.com'],
      backgroundColor: '#2e3c6f',
      actionsBackgroundColor: '#171e37',
      logoUrl: 'https://gdx-cdn.azurewebsites.net/ecosystem/platforms/Literax/images/logo_aserta.png',
    },
    Insurgentes:{
      domains: ['https://insurgentesvn151.literax.com'],
      backgroundColor: '#2e3c6f',
      actionsBackgroundColor: '#171e37',
      logoUrl: 'https://gdx-cdn.azurewebsites.net/ecosystem/platforms/Literax/images/logo_insurgentes.png',
    }
  }
};
